/* Native Shopify theme collector for the dedicated quiz Analytics property.
 * Set destination during build. No Google/Shopify consent state changes. */
(function () {
  'use strict';
  if (['sea-essence.com', 'www.sea-essence.com'].indexOf(window.location.hostname) < 0) return;
  if (window.Shopify && window.Shopify.designMode === true) return;
  if (window.__seQuizAnalyticsListenerV1) return;
  var measurementId = 'G-Z94YYE3Z03';
  var nativeEcommerceId = 'G-T9X49X3RZW';
  var layerName = 'dataLayer';
  var state = {version: 1, queued: 0, consentDropped: 0, unavailableDropped: 0, status: 'waiting', privacyStatus: 'unknown'};
  window.__seQuizAnalyticsListenerV1 = state;
  if (!/^G-[A-Z0-9]{6,}$/.test(measurementId) || measurementId === nativeEcommerceId) {
    state.status = 'invalid_destination';
    return;
  }
  var disableKey = 'ga-disable-' + measurementId;
  var seen = {};
  var seenOrder = [];
  var queue = [];
  var scriptRequested = false;
  var libraryLoaded = false;
  var configured = false;
  var loadFailed = false;
  var privacyRequested = false;
  var legacyRun = 'legacy-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  var legacySeen = {};
  var legacyCompleted = false;
  var eventMap = {
    'se:quiz:start': 'sea_essence_quiz_start',
    'se:quiz:question-view': 'sea_essence_quiz_question_view',
    'se:quiz:question-advance': 'sea_essence_quiz_question_advance',
    'se:quiz:complete': 'sea_essence_quiz_complete',
    'se:quiz:product-click': 'sea_essence_quiz_product_click',
    'se:quiz:close': 'sea_essence_quiz_close',
    'se:quiz:exit': 'sea_essence_quiz_exit'
  };

  function privacyReady() {
    return !!(window.Shopify && window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function');
  }

  function requestPrivacyApi() {
    if (privacyReady()) { state.privacyStatus = 'ready'; return; }
    if (privacyRequested) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      state.privacyStatus = 'unavailable';
      return;
    }
    privacyRequested = true;
    state.privacyStatus = 'loading';
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (error || !privacyReady()) {
          state.privacyStatus = 'error';
          syncPermission();
          return;
        }
        state.privacyStatus = 'ready';
        // Only sync the current permission flag. Earlier dropped quiz activity
        // is never re-emitted when this asynchronous API becomes available.
        syncPermission();
      });
    } catch (_) {
      state.privacyStatus = 'error';
      syncPermission();
    }
  }

  function allowed() {
    try {
      return !!(privacyReady() &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }

  function sanitizeUrl(value) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      return url.origin + url.pathname;
    } catch (_) { return ''; }
  }

  function numericId(value) {
    return typeof value === 'string' && /^\d{1,30}$/.test(value);
  }

  function safeProducts(detail, result) {
    if (numericId(detail.productId)) result.product_id = detail.productId;
    if (numericId(detail.variantId)) result.variant_id = detail.variantId;
    if (Array.isArray(detail.productIds)) {
      var ids = [];
      detail.productIds.forEach(function (id) {
        if (numericId(id) && ids.indexOf(id) < 0) ids.push(id);
      });
      if (ids.length) result.product_ids = ids.join(',').slice(0, 100);
    }
  }

  function normalize(event) {
    var detail = event.detail || {};
    var mapped = eventMap[event.type];
    if (!mapped) return null;
    var result;
    // Brief compatibility window for the published pre-instrumentation hooks.
    // Schema 0 counts at most one start/complete and one product/variant per page.
    // It cannot identify retakes or question progression and does not invent them.
    var legacy = detail.quizId === undefined && detail.schemaVersion === undefined &&
      detail.runId === undefined && detail.eventId === undefined;
    if (legacy) {
      if (['se:quiz:start', 'se:quiz:complete', 'se:quiz:product-click'].indexOf(event.type) < 0) return null;
      var legacyKey = event.type;
      if (event.type === 'se:quiz:product-click') {
        if (!numericId(detail.productId) || !numericId(detail.variantId)) return null;
        legacyKey += ':' + detail.productId + ':' + detail.variantId;
      }
      if (legacySeen[legacyKey]) return null;
      legacySeen[legacyKey] = true;
      if (event.type === 'se:quiz:complete') legacyCompleted = true;
      result = {
        quiz_id: 'sea_essence_routine', quiz_schema_version: 0,
        quiz_run_id: legacyRun,
        quiz_event_id: legacyRun + '.' + Object.keys(legacySeen).length,
        quiz_step_count: 4, quiz_completed: legacyCompleted ? 1 : 0
      };
    } else {
      if (detail.quizId !== 'sea_essence_routine' || detail.schemaVersion !== 1) return null;
      if (typeof detail.runId !== 'string' || !/^[A-Za-z0-9_-]{1,80}$/.test(detail.runId)) return null;
      if (typeof detail.eventId !== 'string' || !/^[A-Za-z0-9_.-]{1,100}$/.test(detail.eventId)) return null;
      if (!Number.isInteger(detail.stepNumber) || detail.stepNumber < 1 || detail.stepNumber > 4 || detail.stepCount !== 4) return null;
      if (typeof detail.completed !== 'boolean') return null;
      result = {
        quiz_id: detail.quizId, quiz_schema_version: detail.schemaVersion,
        quiz_run_id: detail.runId, quiz_event_id: detail.eventId,
        quiz_step: detail.stepNumber, quiz_step_count: detail.stepCount,
        quiz_completed: detail.completed ? 1 : 0
      };
      if (detail.exitReason === 'close' || detail.exitReason === 'page_exit') result.quiz_exit_reason = detail.exitReason;
    }
    safeProducts(detail, result);
    result.send_to = measurementId;
    result.page_location = sanitizeUrl(window.location.href);
    result.page_referrer = sanitizeUrl(document.referrer);
    result.page_title = 'Sea Essence routine quiz';
    result.allow_google_signals = false;
    result.allow_ad_personalization_signals = false;
    return result.page_location ? {name: mapped, params: result} : null;
  }

  function gtag() { window[layerName].push(arguments); }

  function discardQueue() {
    state.consentDropped += queue.length;
    queue = [];
  }

  function syncPermission() {
    var permitted = allowed();
    window[disableKey] = !permitted;
    if (!permitted) discardQueue();
    return permitted;
  }

  function flush() {
    if (!syncPermission() || !libraryLoaded) return;
    if (!configured) {
      configured = true;
      gtag('js', new Date());
      gtag('config', measurementId, {
        send_page_view: false,
        page_location: sanitizeUrl(window.location.href),
        page_referrer: sanitizeUrl(document.referrer),
        page_title: 'Sea Essence routine quiz',
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
    }
    while (queue.length) {
      if (!syncPermission()) return;
      var item = queue.shift();
      gtag('event', item.name, item.params);
      state.queued += 1;
    }
    state.status = 'configured';
  }

  function ensureLibrary() {
    if (!syncPermission() || loadFailed) return;
    if (libraryLoaded) { flush(); return; }
    if (scriptRequested) return;
    scriptRequested = true;
    state.status = 'loading';
    window[layerName] = window[layerName] || [];
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
    script.onload = function () {
      libraryLoaded = true;
      state.status = 'loaded';
      // Do not configure or flush activity if permission changed during loading.
      if (syncPermission()) flush();
    };
    script.onerror = function () {
      loadFailed = true;
      state.status = 'load_failed';
      state.unavailableDropped += queue.length;
      queue = [];
    };
    document.head.appendChild(script);
  }

  function collect(event) {
    requestPrivacyApi();
    if (!syncPermission()) { state.consentDropped += 1; return; }
    var item = normalize(event);
    if (!item) return;
    var id = item.params.quiz_event_id;
    if (seen[id]) return;
    seen[id] = true;
    seenOrder.push(id);
    if (seenOrder.length > 500) delete seen[seenOrder.shift()];
    if (loadFailed) { state.unavailableDropped += 1; return; }
    // Buffer normalized allowlisted data only during this script load. Denied
    // events never enter this queue, and withdrawal discards the entire queue.
    if (queue.length >= 100) { state.unavailableDropped += 1; return; }
    queue.push(item);
    ensureLibrary();
  }

  syncPermission();
  document.addEventListener('visitorConsentCollected', syncPermission);
  Object.keys(eventMap).forEach(function (name) { document.addEventListener(name, collect); });
  if (!privacyReady()) document.addEventListener('DOMContentLoaded', requestPrivacyApi);
  requestPrivacyApi();
})();


(() => {
  'use strict';

  const questionNames = ['goal', 'area', 'sensitivity', 'depth'];
  const validAnswers = {
    goal: ['marks', 'dry', 'simple'],
    area: ['face', 'body', 'both'],
    sensitivity: ['sensitive', 'comfortable', 'unsure'],
    depth: ['simple', 'extra']
  };

  function getRecommendation(answers) {
    if (questionNames.some((name) => !validAnswers[name].includes(answers[name]))) return null;
    const comfortable = answers.sensitivity === 'comfortable';
    const extra = answers.depth === 'extra';
    const face = answers.area !== 'body';
    const body = answers.area !== 'face';
    const targeted = answers.goal === 'marks' && comfortable;
    const steps = [{ key: targeted ? 'turmeric' : 'oats', role: 'cleanse', optional: false }];
    if (targeted && face && extra) steps.push({ key: 'serum', role: 'target', optional: true });
    if (body && extra) steps.push({ key: 'butter', role: 'nourish', optional: false });
    return {
      steps,
      accessory: body && comfortable && extra ? { key: 'bag', role: 'accessory', optional: true } : null,
      cautious: !comfortable,
      simple: steps.length === 1,
      face,
      body,
      bundles: targeted && face && extra
    };
  }

  // An anonymous run lasts for this page's quiz instance. Reopening or editing
  // preserves it; Retake starts a new run. No answer values enter this payload.
  class QuizRun {
    constructor(publish, createId = () => {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
      return `quiz-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    }) {
      this.publish = publish;
      this.runId = createId();
      this.sequence = 0;
      this.emitted = new Set();
    }

    emit(name, detail = {}, key = name) {
      if (this.emitted.has(key)) return null;
      this.emitted.add(key);
      const safeDetail = {
        quizId: 'sea_essence_routine',
        schemaVersion: 1,
        runId: this.runId,
        eventId: `${this.runId}.${++this.sequence}`,
        stepCount: questionNames.length,
        completed: detail.completed === true
      };
      if (Number.isInteger(detail.stepNumber) && detail.stepNumber >= 1 && detail.stepNumber <= questionNames.length) safeDetail.stepNumber = detail.stepNumber;
      if (detail.productId && /^\d+$/.test(String(detail.productId))) safeDetail.productId = String(detail.productId);
      if (detail.variantId && /^\d+$/.test(String(detail.variantId))) safeDetail.variantId = String(detail.variantId);
      if (Array.isArray(detail.productIds)) safeDetail.productIds = [...new Set(detail.productIds.filter((id) => id && /^\d+$/.test(String(id))).map(String))];
      if (['close', 'page_exit'].includes(detail.exitReason)) safeDetail.exitReason = detail.exitReason;
      this.publish(name, safeDetail);
      return safeDetail;
    }
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { getRecommendation, QuizRun };
    return;
  }

  let activeQuiz = null;

  class RoutineQuiz {
    constructor(root) {
      this.root = root;
      const template = root.querySelector('[data-se-quiz-data]');
      try {
        this.data = JSON.parse(template.content.textContent);
      } catch (_error) {
        return;
      }
      this.dialog = root.querySelector('[data-se-quiz-dialog]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.flow = root.querySelector('[data-se-quiz-flow]');
      this.results = root.querySelector('[data-se-quiz-results]');
      this.form = root.querySelector('[data-se-quiz-form]');
      this.heading = root.querySelector('[data-se-quiz-heading]');
      this.hint = root.querySelector('[data-se-quiz-hint]');
      this.next = root.querySelector('[data-se-quiz-next]');
      this.back = root.querySelector('[data-se-quiz-back]');
      this.status = root.querySelector('[data-se-quiz-status]');
      this.answers = {};
      this.step = 0;
      this.resultVisible = false;
      this.completed = false;
      this.analyticsRun = null;
      this.analyticsOpen = false;
      this.returnFocus = null;
      this.ready = true;
      root.dataset.seQuizReady = 'true';
      this.form.addEventListener('change', () => {
        const input = this.form.querySelector(`input[name="${questionNames[this.step]}"]:checked`);
        if (!input) return;
        this.answers[questionNames[this.step]] = input.value;
        this.next.disabled = false;
        this.status.textContent = '';
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        const name = questionNames[this.step];
        if (!validAnswers[name].includes(this.answers[name])) {
          this.status.textContent = this.t('ui.select_answer');
          this.form.querySelector(`input[name="${name}"]`).focus();
          return;
        }
        this.emit('question-advance', {}, `question-advance:${this.step + 1}`);
        if (this.step === questionNames.length - 1) this.showResults();
        else {
          this.step += 1;
          this.showQuestion();
        }
      });
      this.back.addEventListener('click', () => {
        if (this.step > 0) {
          this.step -= 1;
          this.showQuestion();
        }
      });
      root.querySelector('[data-se-quiz-close]').addEventListener('click', () => this.close());
      root.querySelector('[data-se-quiz-retake]').addEventListener('click', () => {
        this.answers = {};
        this.step = 0;
        this.completed = false;
        this.form.reset();
        this.startRun();
        this.showQuestion();
      });
      root.querySelector('[data-se-quiz-edit]').addEventListener('click', () => {
        this.step = 0;
        this.showQuestion();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('close', () => this.afterClose());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      });
      this.results.addEventListener('click', (event) => {
        const link = event.target.closest('[data-se-quiz-product-link]');
        if (!link) return;
        this.emit('product-click', { productId: link.dataset.productId, variantId: link.dataset.variantId }, `product-click:${link.dataset.productId || ''}:${link.dataset.variantId || ''}`);
      });
    }

    t(key, values = {}) {
      return Object.entries(values).reduce((copy, [name, value]) => copy.replace(new RegExp(`{{\\s*${name}\\s*}}|__${name.toUpperCase()}__`, 'g'), String(value)), this.data.strings[key] || '');
    }

    startRun() {
      this.analyticsRun = new QuizRun((name, detail) => {
        this.root.dispatchEvent(new CustomEvent(`se:quiz:${name}`, { bubbles: true, detail }));
      });
      this.emit('start');
    }

    emit(name, detail = {}, key = name) {
      if (!this.analyticsRun) return;
      this.analyticsRun.emit(name, { stepNumber: this.step + 1, completed: this.completed, ...detail }, key);
    }

    trackExit() {
      if (this.analyticsOpen) this.emit('exit', { exitReason: 'page_exit' });
    }

    open(trigger) {
      if (this.dialog.open) return;
      this.returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
      this.cleanUrl = `${window.location.pathname}${window.location.search}${['#quiz', '#routine-quiz'].includes(window.location.hash) ? '' : window.location.hash}`;
      this.dialog.showModal();
      this.analyticsOpen = true;
      if (!this.analyticsRun) this.startRun();
      document.documentElement.classList.add('se-quiz-is-open');
      this.historyPushed = !['#quiz', '#routine-quiz'].includes(window.location.hash);
      if (this.historyPushed) history.pushState(history.state, '', '#routine-quiz');
      if (this.resultVisible) this.root.querySelector('[data-se-quiz-results-heading]').focus({ preventScroll: true });
      else this.showQuestion();
    }

    close(cleanHash = true) {
      if (!this.dialog.open) return;
      this.skipHashCleanup = !cleanHash;
      if (cleanHash && ['#quiz', '#routine-quiz'].includes(window.location.hash)) {
        if (this.historyPushed) {
          this.skipHashCleanup = true;
          this.historyPushed = false;
          history.back();
        } else history.replaceState(history.state, '', this.cleanUrl || `${window.location.pathname}${window.location.search}`);
      }
      this.dialog.close();
    }

    afterClose() {
      if (this.analyticsOpen) {
        this.analyticsOpen = false;
        this.emit('close', { exitReason: 'close' });
      }
      document.documentElement.classList.remove('se-quiz-is-open');
      if (!this.skipHashCleanup && ['#quiz', '#routine-quiz'].includes(window.location.hash)) history.replaceState(history.state, '', this.cleanUrl || `${window.location.pathname}${window.location.search}`);
      this.skipHashCleanup = false;
      if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({ preventScroll: true });
    }

    showQuestion() {
      this.resultVisible = false;
      this.flow.hidden = false;
      this.results.hidden = true;
      const name = questionNames[this.step];
      this.heading.textContent = this.t(`questions.${name}_title`);
      this.hint.textContent = this.t(`questions.${name}_hint`);
      this.root.querySelectorAll('[data-se-quiz-question]').forEach((fieldset) => {
        fieldset.hidden = fieldset.dataset.seQuizQuestion !== name;
      });
      this.root.querySelector('[data-se-quiz-step]').textContent = this.t('ui.progress', { current: this.step + 1, total: questionNames.length });
      const progress = this.root.querySelector('[data-se-quiz-progress]');
      progress.setAttribute('aria-valuenow', this.step + 1);
      progress.firstElementChild.style.width = `${((this.step + 1) / questionNames.length) * 100}%`;
      this.back.hidden = this.step === 0;
      this.root.querySelector('.se-quiz__selection-hint').hidden = this.step !== 0;
      this.next.disabled = !validAnswers[name].includes(this.answers[name]);
      this.next.firstChild.textContent = this.t(this.step === questionNames.length - 1 ? 'ui.results_button' : 'ui.next');
      this.status.textContent = '';
      this.root.querySelector('.se-quiz__panel').scrollTop = 0;
      if (this.dialog.open) {
        this.heading.focus({ preventScroll: true });
        this.emit('question-view', {}, `question-view:${this.step + 1}`);
      }
    }

    productCard(step, number) {
      const product = this.data.products[step.key] || {};
      const title = ['turmeric', 'oats'].includes(step.key) ? this.t(`products.${step.key}_title`) : product.title || this.t(`products.${step.key}_title`);
      const card = document.createElement('article');
      card.className = 'se-quiz__product';
      card.dataset.productKey = step.key;
      const media = document.createElement('div');
      media.className = 'se-quiz__product-media';
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        if (product.imageSmall) image.srcset = `${product.imageSmall} 210w, ${product.image} 420w`;
        image.sizes = '(max-width: 599px) 100px, 140px';
        image.alt = title;
        image.width = product.imageWidth;
        image.height = product.imageHeight;
        image.loading = 'lazy';
        image.decoding = 'async';
        media.append(image);
      }
      const copy = document.createElement('div');
      copy.className = 'se-quiz__product-copy';
      const role = document.createElement('p');
      role.className = 'se-quiz__product-role';
      role.textContent = `${number ? `${number}. ` : ''}${this.t(`ui.${step.role}`)}`;
      if (step.optional) {
        const optional = document.createElement('span');
        optional.className = 'se-quiz__optional-label';
        optional.textContent = this.t('ui.optional');
        role.append(optional);
      }
      const heading = document.createElement('h3');
      heading.textContent = title;
      const reason = document.createElement('p');
      reason.className = 'se-quiz__product-reason';
      reason.textContent = this.t(`products.${step.key}_reason`);
      const details = document.createElement('details');
      details.className = 'se-quiz__directions';
      const summary = document.createElement('summary');
      summary.textContent = this.t('ui.why');
      const directions = document.createElement('p');
      directions.textContent = this.t(`products.${['turmeric', 'oats'].includes(step.key) ? 'soap' : step.key}_directions`);
      details.append(summary, directions);
      const actions = document.createElement('div');
      actions.className = 'se-quiz__product-actions';
      if (product.available && product.price) {
        const price = document.createElement('strong');
        price.className = 'se-quiz__price';
        price.textContent = product.price;
        actions.append(price);
      }
      if (!product.available) {
        const stock = document.createElement('p');
        stock.className = 'se-quiz__stock';
        stock.textContent = this.t('ui.unavailable');
        const stockNote = document.createElement('p');
        stockNote.className = 'se-quiz__stock-note';
        stockNote.textContent = this.t(product.url ? 'ui.unavailable_note' : 'ui.missing_note');
        copy.append(stock, stockNote);
      }
      if (product.url) {
        const link = document.createElement('a');
        link.className = 'se-quiz__shop-step';
        link.href = product.url;
        link.textContent = this.t(product.available ? 'ui.shop_step' : 'ui.view_product');
        link.setAttribute('aria-label', `${link.textContent}: ${title}`);
        link.dataset.seQuizProductLink = '';
        link.dataset.productId = product.productId || '';
        link.dataset.variantId = product.variantId || '';
        actions.append(link);
        const ingredients = document.createElement('a');
        ingredients.className = 'se-quiz__ingredients';
        ingredients.href = product.url;
        ingredients.textContent = this.t('ui.ingredients');
        ingredients.setAttribute('aria-label', `${ingredients.textContent}: ${title}`);
        ingredients.dataset.seQuizProductLink = '';
        ingredients.dataset.productId = product.productId || '';
        ingredients.dataset.variantId = product.variantId || '';
        details.append(ingredients);
      } else if (this.data.browseUrl) {
        const browse = document.createElement('a');
        browse.className = 'se-quiz__shop-step';
        browse.href = this.data.browseUrl;
        browse.textContent = this.t('ui.browse');
        actions.append(browse);
      }
      copy.prepend(role, heading, reason);
      copy.append(details, actions);
      card.append(media, copy);
      return card;
    }

    showResults() {
      const recommendation = getRecommendation(this.answers);
      if (!recommendation) return;
      this.resultVisible = true;
      this.flow.hidden = true;
      this.results.hidden = false;
      this.root.querySelector('[data-se-quiz-result-intro]').textContent = this.t(recommendation.simple ? 'ui.results_simple' : 'ui.results_extra');
      this.root.querySelector('[data-se-quiz-cautious]').hidden = !recommendation.cautious;
      const products = this.root.querySelector('[data-se-quiz-products]');
      products.replaceChildren(...recommendation.steps.map((step, index) => this.productCard(step, index + 1)));
      const optional = this.root.querySelector('[data-se-quiz-optional]');
      optional.hidden = !recommendation.accessory;
      this.root.querySelector('[data-se-quiz-accessories]').replaceChildren(...(recommendation.accessory ? [this.productCard(recommendation.accessory)] : []));
      const soap = this.data.products.turmeric;
      const serum = this.data.products.serum;
      const bundles = recommendation.bundles && soap?.available && serum?.available && soap?.url;
      this.root.querySelector('[data-se-quiz-bundle]').hidden = !bundles;
      const bundleLink = this.root.querySelector('[data-se-quiz-bundle-link]');
      if (bundles) {
        bundleLink.href = soap.url;
        bundleLink.dataset.seQuizProductLink = '';
        bundleLink.dataset.productId = soap.productId || '';
        bundleLink.dataset.variantId = soap.variantId || '';
      } else {
        bundleLink.removeAttribute('href');
        delete bundleLink.dataset.seQuizProductLink;
        delete bundleLink.dataset.productId;
        delete bundleLink.dataset.variantId;
      }
      this.root.querySelector('[data-se-quiz-area-care]').textContent = [recommendation.face ? this.t('ui.results_face') : '', recommendation.body ? this.t('ui.results_body') : ''].filter(Boolean).join(' ');
      this.root.querySelector('.se-quiz__panel').scrollTop = 0;
      this.root.querySelector('[data-se-quiz-results-heading]').focus({ preventScroll: true });
      if (!this.completed) {
        this.completed = true;
        this.emit('complete', { productIds: [...new Set(recommendation.steps.map((step) => this.data.products[step.key]?.productId))] });
      }
    }
  }

  function styleQuizNavigation(scope = document) {
    scope.querySelectorAll('header .header__inline-menu a[href], header .menu-drawer__navigation a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || !['#quiz', '#routine-quiz'].includes(url.hash)) return;
      } catch (_error) {
        return;
      }
      const label = link.querySelector('span') || link;
      label.textContent = 'Take the Skin Quiz';
      link.setAttribute('aria-label', 'Take the Skin Quiz');
      link.classList.add('se-quiz-nav-cta');
    });
  }

  function initialize(scope = document) {
    styleQuizNavigation(scope);
    scope.querySelectorAll('[data-se-quiz-root]:not([data-se-quiz-ready])').forEach((root) => {
      const quiz = new RoutineQuiz(root);
      if (quiz.ready) activeQuiz = quiz;
    });
    if (activeQuiz && ['#quiz', '#routine-quiz'].includes(window.location.hash)) activeQuiz.open();
  }

  document.addEventListener('click', (event) => {
    if (!activeQuiz || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest('[data-se-quiz-open], a[href]');
    if (!trigger) return;
    let targeted = trigger.hasAttribute('data-se-quiz-open');
    if (!targeted && trigger.tagName === 'A') {
      try {
        const url = new URL(trigger.href, window.location.href);
        targeted = url.origin === window.location.origin && ['#quiz', '#routine-quiz'].includes(url.hash);
      } catch (_error) {
        return;
      }
    }
    if (!targeted) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    activeQuiz.open(trigger);
  }, true);
  const syncHash = () => {
    if (!activeQuiz) return;
    if (['#quiz', '#routine-quiz'].includes(window.location.hash)) activeQuiz.open();
    else activeQuiz.close(false);
  };
  window.addEventListener('pagehide', () => { if (activeQuiz) activeQuiz.trackExit(); });
  window.addEventListener('hashchange', syncHash);
  window.addEventListener('popstate', syncHash);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeQuiz && event.target.contains(activeQuiz.root)) {
      activeQuiz.close();
      activeQuiz = null;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
